const system =
{
     // ApiUrl: 'http://192.168.200.245:30000/',
     ApiUrl: 'https://api.niujiapai.com/',
     MapUrl: 'https://map.niujiapai.com/',
}

export default system
